module.exports = __webpack_public_path__ + "static/media/USYGY100086.103f45b5.jpg";